import Chip from "@material-ui/core/Chip";
// material-ui
import { withStyles } from "@material-ui/styles";
// custom
import Table from "components/Table";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import TableEdit from "../TableEdit";
// styles
import styles from "./styles";

class InstrumentSectionsList extends PureComponent {
  static propTypes = {
    // classes: PropTypes.object,
    instrumentSections: PropTypes.array,
    onSelect: PropTypes.func,
  };

  onSelect(selectedInstrumentSection) {
    const { onSelect } = this.props;
    if (onSelect) {
      onSelect(selectedInstrumentSection);
    }
  }

  render() {
    const { instrumentSections } = this.props;

    return (
      <Table
        data={instrumentSections}
        meta={[
          {
            path: "id",
            title: "ID",
            width: 30,
          },
          {
            path: "name",
            title: "Name",
            numeric: false,
          },
          {
            path: "familyName",
            title: "Family",
            render: (t) => <Chip label={t} />,
          },
          {
            path: "id",
            numeric: false,
            component: TableEdit,
            inject: {
              onEdit: this.onSelect.bind(this),
            },
            width: 30,
          },
        ]}
        title={"Instrument Sections"}
        onRowSelect={() => console.log("Clicked")}
      />
    );
  }
}

export default withStyles(styles)(InstrumentSectionsList);
